import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Account } from "@rentablo/api/apiv1";
import { Badge } from "@rentablo/components";
import AccountPreviewIcon from "@components/Accounts/AccountPreviewCard/AccountPreviewIcon";

interface AccountEditHeaderProps {
  account?: Account;
}

export const AccountEditHeader = ({ account }: AccountEditHeaderProps) => {
  const { t } = useTranslation();

  if (!account) return null;

  const subtitle = [account.bankName, account.iban].filter(Boolean).join(" · ");

  return (
    <Box display="flex" alignItems="center" gap={4} mb={7}>
      <AccountPreviewIcon
        isReference={false}
        iconUrl={account.iconUrl ?? ""}
        type={account.type ?? "01_depot"}
        size={56}
      />
      <Box display="flex" flexDirection="column" gap={1} minWidth={0}>
        <Box display="flex" alignItems="center" gap={3} flexWrap="wrap">
          <Typography variant="h4">{account.name}</Typography>
          <Badge variant="primary">{t(`accountTypes.${account.type}`)}</Badge>
        </Box>
        {subtitle && (
          <Typography variant="body3" color="textSecondary">
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
